// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"409":"f8e8984b","412":"2abaaedc","415":"b5b9da5b","520":"af068415"}[chunkId] + ".chunk.css";
};